import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DocumentListItem } from '../DocumentListItem/DocumentListItem';
import { TsrctFile } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { WidgetContentEmpty } from '~/components/WidgetContentEmpty/WidgetContentEmpty';

export interface DemandDocumentContentProps {
  files: Omit<TsrctFile, 'demandId' | 'uploadedBy'>[];
  loading?: boolean;
}
export const DemandDocumentContent = ({ files, loading }: DemandDocumentContentProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'DemandDocumentWidget' });

  return (
    <>
      {loading || files.length === 0 ? (
        <WidgetContentEmpty title={t('empty')} />
      ) : (
        <List disablePadding>
          {files.map((file) => (
            <DocumentListItem key={file.id} file={file} />
          ))}
        </List>
      )}
    </>
  );
};
